<div *ngIf="alertIsOpened && showAlert" class="alert-container">
    <mat-icon class="alert-icon">warning</mat-icon>
    <div class="alert-message">
      {{ 'portal.alert' | translate }}
    </div>
    <button
        mat-icon-button
        class="alert-close"
        [disableRipple]="true"
        (click)="onAlertClose()"
    >
        <mat-icon>close</mat-icon>
    </button>
</div>

<app-portal 
    [ngClass]=" hasHeader ? (alertIsOpened && showAlert? 'portal-hasHeader-hasAlert-hasMenu' : 'portal-hasHeader-hasMenu') : (alertIsOpened && showAlert ? 'portal-hasAlert-hasMenu' : 'portal-hasMenu')">
</app-portal>
